module.exports = "<div class=\"row\">\n\t<div class=\"col-xs-12\">\n\n\t\t<u-tree \n\t\t\te-nodes=\"Ctrl.input\" \n\t\t\te-options=\"{inEdit: false}\" \n\t\t\tng-if=\"Ctrl.input.data.length > 0\" >\n\t\t</u-tree>\n\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/input-form-view/templates/structure-view.html
// module id = 313
// module chunks = 0